import React, { useState, useEffect, useRef } from 'react';
import './AnimatedSubtitles.css';

const AnimatedSubtitles = ({ 
  text = '', 
  isVisible = false, 
  typingSpeed = 50, 
  autoHideDuration = 3000,
  onComplete = null,
  className = ''
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);
  const typingTimeoutRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  // Clear timeouts on unmount
  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, []);

  // Handle text changes and visibility
  useEffect(() => {
    if (isVisible && text) {
      setShouldShow(true);
      setDisplayedText('');
      setIsTyping(true);
      
      // Clear any existing timeouts
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
      
      // Start typing animation
      let currentIndex = 0;
      
      const typeNextCharacter = () => {
        if (currentIndex < text.length) {
          setDisplayedText(text.substring(0, currentIndex + 1));
          currentIndex++;
          typingTimeoutRef.current = setTimeout(typeNextCharacter, typingSpeed);
        } else {
          // Typing complete
          setIsTyping(false);
          if (onComplete) onComplete();
          
          // Auto-hide after duration
          hideTimeoutRef.current = setTimeout(() => {
            setShouldShow(false);
            setDisplayedText('');
          }, autoHideDuration);
        }
      };
      
      // Start typing
      typingTimeoutRef.current = setTimeout(typeNextCharacter, typingSpeed);
      
    } else if (!isVisible) {
      // Hide immediately when isVisible becomes false
      setShouldShow(false);
      setDisplayedText('');
      setIsTyping(false);
      
      // Clear timeouts
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    }
  }, [isVisible, text, typingSpeed, autoHideDuration, onComplete]);

  if (!shouldShow) return null;

  return (
    <div className={`animated-subtitles ${className} ${shouldShow ? 'visible' : ''}`}>
      <div className="subtitle-container">
        <div className="subtitle-background">
          <span className="subtitle-text">
            {displayedText}
            {isTyping && <span className="typing-cursor">|</span>}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AnimatedSubtitles;
